import { render, staticRenderFns } from "./uSwitch.vue?vue&type=template&id=dc7c604e&scoped=true&"
import script from "./uSwitch.vue?vue&type=script&lang=js&"
export * from "./uSwitch.vue?vue&type=script&lang=js&"
import style0 from "./uSwitch.vue?vue&type=style&index=0&id=dc7c604e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7c604e",
  null
  
)

export default component.exports